/**
 * Theme preselection (Hospitality / Entertainment / Office) visibility.
 * Used to hide Onyx FAB while the selector covers the viewport.
 */

export const THEME_PRESELECT_EVENT = 'komby:theme-preselect';

const DATA_ATTR = 'kombyThemePreselect';

export function isThemePreselectPath(pathname: string = window.location.pathname): boolean {
  const hasSkinInUrl = /\/(resto|office|nightclub)\/?/.test(pathname);
  if (hasSkinInUrl) return false;
  return pathname === '/' || /^\/[a-z]{2}(-[A-Z]{2})?\/?$/i.test(pathname);
}

export function setThemePreselectVisible(visible: boolean): void {
  if (typeof document === 'undefined') return;
  if (visible) {
    document.documentElement.dataset[DATA_ATTR] = '1';
  } else {
    delete document.documentElement.dataset[DATA_ATTR];
  }
  window.dispatchEvent(
    new CustomEvent(THEME_PRESELECT_EVENT, { detail: { visible } }),
  );
}

export function isThemePreselectVisible(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.dataset[DATA_ATTR] === '1';
}
